import { useEffect, useRef, useState } from 'react';

import { PencilEdit01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useCombinedRefs } from '../../../hooks/combined-refs';
import styles from './EditableTitle.module.scss';

export const EditableTitle = ({ name, value, disabled, register = () => {} }) => {
  const { ref, ...registerProps } = register(name);
  const inputRef = useRef(null);
  const combinedRef = useCombinedRefs(ref, inputRef);

  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (editing) inputRef.current.focus();
  }, [editing]);

  const cancel = () => setEditing(false);

  const handleKeyPressed = e => {
    if (e.key === 'Enter') {
      setEditing(false);
    }
  };

  return (
    <div
      className={cn('flex items-center gap-2 justify-between', styles.root, {
        [styles.rootDisabled]: disabled,
        'border border-neutral-4 rounded-2xl p-4': editing,
      })}
      onClick={() => {
        if (!disabled) setEditing(true);
      }}>
      {editing ? (
        <input
          ref={combinedRef}
          className={cn('text-3xl font-semibold', styles.input)}
          {...registerProps}
          onBlur={cancel}
          onKeyPress={handleKeyPressed}
        />
      ) : (
        <h1 className="text-3xl font-semibold">{value}</h1>
      )}
      {!disabled && (
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="top"
          overlay={<Tooltip>Edit</Tooltip>}>
          <div className="cursor-pointer">
            <HugeiconsIcon icon={PencilEdit01Icon} className="text-neutral-6" />
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
};

EditableTitle.propTypes = {
  register: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
};
